<template>
    <div class="login">
        <div class="formbox">

            <h3 class="text-center white f36 pos-a title" style="margin-top:-150px;">设备管理系统</h3>

            <div class="padding15">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="经销商登录" name="1"></el-tab-pane>
                    <el-tab-pane label="集团账户登录" name="2"></el-tab-pane>
                </el-tabs>
            </div>

            <el-form label-width="100px" label-color="#fff">

                <el-form-item label="集团ID" v-if="activeName == 2">
                    <input type="text" class="codemore" v-model="groupid" placeholder="请输入集团ID">
                </el-form-item>

                <el-form-item label="手机号码">
                    <input type="text" class="codemore" maxlength="11" v-model="phone" placeholder="请输入手机号码">
                </el-form-item>

                <el-form-item label="图片验证码">
                    <input type="text" class="codemore" style="width: 120px; " v-model="imagecode" placeholder="请输入图片验证码">

                    <img @click="getImageCode" :src="imageContent" alt="" style="vertical-align: bottom; display: inline-block; width: 90px; height: 40px; margin-left: 12px;">
                </el-form-item>

                <el-form-item label="验证码">
                    <input type="text" class="codemore" style="width: 120px;" v-model="signcode" placeholder="请输入验证码">
                    <div class="inline-b">
                        <div v-if="countDownType">
                            <a href="javascript:;" class="getbtn white">({{countDownTime}}s)</a>
                        </div>
                        <div v-else>
                            <a href="javascript:;" class="getbtn white" style="background: #53e3a6" @click="sendCode">获取验证码</a>
                        </div>
                    </div>
                </el-form-item>
            </el-form>

            <div class="loginbtn" @click="login()">登录</div>
        </div>

        <div class="wrapper">
            <ul class="bg-bubbles">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul>
        </div>
    </div>
</template>

<script>
    var IntervalName;
    export default {
        name: 'login',
        data() {
            return {
                groupid: '',
                phone: '',
                signcode: '',
                imagecode: '',
                imageContent: '',
                imageCodeKey: '',
                countDownType: false,
                countDownTime: 180,
                show: false,
                msg: {
                    show: false,
                    index: 0,
                },
                activeName: '1',
                channel: 0
            }
        },
        created() {
            let that = this;

            //单点登录
            let tid = that.getUrlParam("tid");
            if (tid) {
                that.loginbytid(tid.split("#")[0]);
                return;
            }

            if (!that.accountutil.isRedirectLogin()) {
                this.getaccount();
            }

            this.getImageCode();
        },
        methods: {
            // 发送验证码
            sendCode() {
                var that = this;
                var mobilePhone = that.phone;

                if(!that.imagecode || !that.imagecode.trim()) {
                    that.$message({
                        message: "请输入图片验证码",
                        type: 'warning'
                    });

                    return;
                }

                if (!(/\d{11}/.test(mobilePhone))) {
                    that.$message({
                        message: '手机号有误，请填写正确的手机号',
                        type: 'warning'
                    });
                } else {
                    var req = {
                        mobilePhone: mobilePhone,
                        clazz: 'login',
                        imagekey: that.imageCodeKey,
                        imagesign: that.imagecode.trim(),
                    };
                    req = JSON.stringify(req);
                    var countDownTime = that.countDownTime;
                    if (countDownTime == 180) {
                        that.countDownType = true;
                        $.ajax({
                            type: 'post',
                            url: that.api.verifycode,
                            data: {
                                req: req
                            },
                            success: function (res) {
                                if (res.result.success) {
                                    that.countDownType = true;

                                    IntervalName = setInterval(function () {
                                        if (countDownTime == 0) {
                                            that.countDownType = false;
                                            that.countDownTime = 180;
                                            clearInterval(IntervalName);
                                            IntervalName = null;
                                        } else {
                                            that.countDownTime = countDownTime - 1;
                                            countDownTime--;
                                        }
                                    }, 1000)
                                } else {
                                    that.$message({
                                        message: res.result.reason,
                                        type: 'warning'
                                    });
                                }
                            }
                        })
                    }
                }
            },
            getaccount() {
                var that = this;
                var req = {
                    sid: 3,
                    typename: 'xmiss'
                };
                that.httputil.post({
                    that: that,
                    url: that.api.getaccount,
                    req: req,
                    xmsuccess: function (res) {
                        if (res.user) {
                            that.$emit('showDetail', true);
                        }
                    },
                    xmfail: function (res) {

                    }
                });
            },
            login() {
                var that = this;
                var phone = that.phone;
                var phoneCode = that.signcode;
                if (!(/\d{11}/.test(phone))) {
                    that.$message({
                        message: '输入的手机号码不正确！请重新输入！',
                        type: 'warning'
                    });
                    return false;
                }
                if (phoneCode == '') {
                    that.$message({
                        message: '验证码不能为空！',
                        type: 'warning'
                    });
                    return false;
                }
                var req = {
                    loginType: 6,
                    mobilePhone: phone,
                    sign: phoneCode,
                    sid: 1,
                    channel: 'xmiss'
                };
                if (that.channel == 0) {
                    that.accountutil.setLoginTypeAgent();
                    that.httputil.post({
                        that: that,
                        url: that.api.loginUrl,
                        req: req,
                        xmsuccess: function (res) {
                            that.$emit('showDetail', true);
                        },
                        xmfail: function (res) {
                            that.$message({
                                message: res.result.reason,
                                type: 'warning'
                            });
                        }
                    });
                } else {
                    if (that.groupid == '') {
                        that.$message({
                            message: '集团ID不能为空！',
                            type: 'warning'
                        });
                        return false;
                    }
                    that.accountutil.setLoginTypeGroup();
                    var bid = parseInt(that.groupid);
                    var req1 = {
                        loginType: 5,
                        mobilePhone: phone,
                        sign: phoneCode,
                        bid: bid,
                        channel: 'groupadmin',
                        sid: 1,
                    }
                    that.httputil.post({
                        that: that,
                        url: that.api.loginUrl,
                        req: req1,
                        xmsuccess: function (res) {
                            that.$emit('showDetail', true);
                        },
                        xmfail: function (res) {
                            that.$message({
                                message: res.result.reason,
                                type: 'warning'
                            });
                        }
                    });
                }
            },
            handleClick(tab) {
                console.log(tab.index);
                var that = this;
                that.phone = '';
                that.signcode = '';
                that.bid = '';
                that.countDownType = false;
                that.countDownTime = 180;
                clearInterval(IntervalName);
                IntervalName = null;
                that.channel = tab.index
            },

            loginbytid: function (tid) {
                let that = this;
                if (!tid) {
                    return;
                }
                that.accountutil.clearRedirectLogin();

                that.httputil.post({
                    url: that.api.loginbytid,
                    req: {tid: tid},
                    xmsuccess: function (res) {
                        if (5 == res.scenetype) {
                            that.accountutil.setLoginTypeGroup();
                        }
                        if (6 == res.scenetype) {
                            that.accountutil.setLoginTypeAgent();
                        }

                        window.location = "/";
                    },
                    xmfail: function (res) {
                        window.location = "/";
                    }
                });
            },
            getUrlParam: function (paraName) {
                var url = document.location.toString();
                var arrObj = url.split("?");

                if (arrObj.length > 1) {
                    var arrPara = arrObj[1].split("&");
                    var arr;

                    for (var i = 0; i < arrPara.length; i++) {
                        arr = arrPara[i].split("=");

                        if (arr != null && arr[0] == paraName) {
                            return arr[1];
                        }
                    }
                    return "";
                } else {
                    return "";
                }
            },
            getImageCode() {
                let that = this;

                let req = {
                    clazz: "login"
                };

                that.httputil.post({
                    that: that,
                    url: that.api.getimagecode,
                    req: req,
                    xmsuccess: function (res) {
                        that.imageContent = "data:image/jpg;base64," + res.imagecode;
                        that.imageCodeKey = res.skey;
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .formbox {
        background: rgba(0, 0, 0, .1);
        position: relative;
        padding: 20px;
        border-radius: 10px;
        color: #fff;
        z-index: 999;
    }

    .login {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 997;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .wrapper {
        background: #50a3a2;
        background: -webkit-linear-gradient(top left, #50a3a2 0%, #53e3a6 100%);
        background: linear-gradient(to bottom right, #50a3a2 0%, #53e3a6 100%);
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        z-index: 998;
    }

    .wrapper.form-success .container h1 {
        -webkit-transform: translateY(85px);
        transform: translateY(85px);
    }

    .container h1 {
        font-size: 40px;
        -webkit-transition-duration: 1s;
        transition-duration: 1s;
        -webkit-transition-timing-function: ease-in-put;
        transition-timing-function: ease-in-put;
        font-weight: 200;
    }

    .bg-bubbles {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    .bg-bubbles li {
        position: absolute;
        list-style: none;
        display: block;
        width: 40px;
        height: 40px;
        background-color: rgba(255, 255, 255, 0.15);
        bottom: -160px;
        -webkit-animation: square 35s infinite;
        animation: square 35s infinite;
        -webkit-transition-timing-function: linear;
        transition-timing-function: linear;
    }

    .bg-bubbles li:nth-child(1) {
        left: 10%;
    }

    .bg-bubbles li:nth-child(2) {
        left: 20%;
        width: 80px;
        height: 80px;
        -webkit-animation-delay: 2s;
        animation-delay: 2s;
        -webkit-animation-duration: 17s;
        animation-duration: 17s;
    }

    .bg-bubbles li:nth-child(3) {
        left: 25%;
        -webkit-animation-delay: 4s;
        animation-delay: 4s;
    }

    .bg-bubbles li:nth-child(4) {
        left: 40%;
        width: 60px;
        height: 60px;
        -webkit-animation-duration: 22s;
        animation-duration: 22s;
        background-color: rgba(255, 255, 255, 0.25);
    }

    .bg-bubbles li:nth-child(5) {
        left: 70%;
    }

    .bg-bubbles li:nth-child(6) {
        left: 80%;
        width: 120px;
        height: 120px;
        -webkit-animation-delay: 3s;
        animation-delay: 3s;
        background-color: rgba(255, 255, 255, 0.2);
    }

    .bg-bubbles li:nth-child(7) {
        left: 32%;
        width: 160px;
        height: 160px;
        -webkit-animation-delay: 7s;
        animation-delay: 7s;
    }

    .bg-bubbles li:nth-child(8) {
        left: 55%;
        width: 20px;
        height: 20px;
        -webkit-animation-delay: 15s;
        animation-delay: 15s;
        -webkit-animation-duration: 40s;
        animation-duration: 40s;
    }

    .bg-bubbles li:nth-child(9) {
        left: 25%;
        width: 10px;
        height: 10px;
        -webkit-animation-delay: 2s;
        animation-delay: 2s;
        -webkit-animation-duration: 40s;
        animation-duration: 40s;
        background-color: rgba(255, 255, 255, 0.3);
    }

    .bg-bubbles li:nth-child(10) {
        left: 90%;
        width: 160px;
        height: 160px;
        -webkit-animation-delay: 11s;
        animation-delay: 11s;
    }

    @-webkit-keyframes square {
        0% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
        }
        100% {
            /*-1080px代表从下向上移动多少   600deg代表从下向上移动过程中旋转600度*/
            -webkit-transform: translateY(-1080px) rotate(600deg);
            transform: translateY(-1080px) rotate(600deg);
        }
    }

    @keyframes square {
        0% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
        }
        100% {
            -webkit-transform: translateY(-1080px) rotate(600deg);
            transform: translateY(-1080px) rotate(600deg);
        }
    }

    .codemore {
        height: 40px;
        width: 240px;
        padding: 0 6px;
        border-radius: 6px;
        outline: none;
        border: 1px solid #ddd;
    }

    .getbtn {
        background: rgb(99, 218, 168);
        height: 40px;
        line-height: 40px;
        width: 100px;
        text-align: center;
        display: inline-block;
        border-radius: 6px;
        margin-left: 12px;
    }

    .loginbtn {
        width: 80%;
        margin: 0 auto;
        height: 40px;
        line-height: 40px;
        background: rgba(174, 233, 207, 0.5);
        text-align: center;
        cursor: pointer;
        border-radius: 6px;
    }

    .title {
        width: 100%;
        top: 40px;
        z-index: 99999;
    }
</style>


// WEBPACK FOOTER //
// src/pages/login.vue